import { render, staticRenderFns } from "./ContextMenu2.vue?vue&type=template&id=4b030b47&lang=pug"
import script from "./ContextMenu2.vue?vue&type=script&lang=js"
export * from "./ContextMenu2.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu2.vue?vue&type=style&index=0&id=4b030b47&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports